import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import CustomLabel from "../../../sub/CustomLabel";
import AutoSuggestInput from "../../../sub/fields/autosuggest/AutoSuggestInput.js";
import Util from "../../../../util/Util";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { useState } from "react";
import MenuButton from "../../../sub/bootstrap/MenuButton";
import SwitchToggle from "../../../sub/SwitchToggle";

function CreateCheckpointModal({
  auditDMId,
  checkpoint,
  checkpoints,
  addCheckpoint,
  onUpdateCheckpoint,
  close,
  intl,
}) {
  const [checkpointName, setCheckpointName] = useState(
    checkpoint ? checkpoint.name : "",
  );
  const [checkpointNameError, setCheckpointNameError] = useState("");

  const [isGlobalEdit, setIsGlobalEdit] = useState(false);

  const add = () => {
    if (Util.emptyString(checkpointName)) return;

    addCheckpoint(checkpointName.trim());
  };

  const update = () => {
    if (!auditDMId || !checkpoint || Util.emptyString(checkpointName)) return;

    const data = {
      auditDMId: auditDMId,
      checkpointId: checkpoint._id,
      updatedField: "name",
      updatedValue: checkpointName,
      isGlobal: isGlobalEdit,
    };
    onUpdateCheckpoint(data);
    close();
  };

  const onChange = (value) => {
    setCheckpointName(value);
    if (checkpoint) {
      setCheckpointNameError(
        getCheckpointsNames(checkpoints).includes(value) ? (
          <FormattedMessage id="Checkpoint.Already.Exists" />
        ) : (
          ""
        ),
      );
    }
  };

  const getCheckpointsNames = (checkpoints) => {
    if (!checkpoints) return [];

    const names = [];
    for (const c of checkpoints) names.push(c.name);
    return names;
  };

  return (
    <Modal
      show={true}
      onHide={() => close()}
      backdrop={"static"}
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage
            id={checkpoint ? "Modify.Checkpoint" : "Add.Checkpoint"}
          />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group as={Row} className="mb-3 align-items-center">
          <CustomLabel
            label={intl.formatMessage({ id: "Description" })}
            displayAsCol
            htmlFor="checkpoint"
            required={true}
          />
          <Col md={7}>
            <AutoSuggestInput
              onChange={(value) => onChange(value)}
              value={checkpointName}
              onSuggestionSelected={() => {}}
              suggestions={getCheckpointsNames(checkpoints)}
            />
            <div className="text-danger">
              <small>{checkpointNameError}</small>
            </div>
          </Col>
        </Form.Group>

        {checkpoint && (
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={intl.formatMessage({ id: "Checkpoint.Edit.Global" })}
              displayAsCol
              htmlFor="is-global-edit"
            />
            <Col md={7}>
              <SwitchToggle
                htmlFor={"is-global-edit"}
                id="is-global-edit"
                onChange={(e) => setIsGlobalEdit(!isGlobalEdit)}
                checked={isGlobalEdit}
              />
            </Col>
          </Form.Group>
        )}
      </Modal.Body>

      <Modal.Footer>
        <MenuButton variant="secondary" onClick={() => close()}>
          <FormattedMessage id="Cancel" />
        </MenuButton>
        <MenuButton
          onClick={() => {
            checkpoint ? update() : add();
          }}
          disabled={
            !Util.emptyString(checkpointNameError) ||
            Util.emptyString(checkpointName) ||
            (checkpoint && checkpointName === checkpoint.name)
          }
        >
          <FormattedMessage id={checkpoint ? "Modify" : "Add"} />
        </MenuButton>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    checkpoints: state.checkpoints,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CreateCheckpointModal));
